import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import './Transformations.css';

const { FiArrowUpRight } = FiIcons;

const looks = [
  {
    title: 'Soft colour,full of life',
    category: 'COLOUR & CARE',
    image: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/fc35c186c4617b9990a89ff146f7e322.webp',
    alt: 'Soft,dimensional hair colour',
    className: 'inspiration-card inspiration-card-colour'
  },
  {
    title: 'A little glow,a lot like you',
    category: 'MAKEUP',
    image: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/d60a02eb202024d04acb90d234ceb781.webp',
    alt: 'A softly finished makeup look',
    className: 'inspiration-card inspiration-card-makeup'
  }
];

function Transformations() {
  return (
    <section className="section work-section inspiration-section" id="work">
      <div className="container">
        <Reveal className="inspiration-intro">
          <span className="eyebrow">A little inspiration</span>
          <h2>Looks to love.<br /><em>Ideas to make your own.</em></h2>
          <p>From the everyday refresh to a little something special,find a look that feels like you.</p>
          <a className="inspiration-link" href="#appointment">
            Let’s talk about your look <SafeIcon icon={FiArrowUpRight} />
          </a>
        </Reveal>
        <div className="inspiration-gallery">
          <Reveal className="inspiration-card inspiration-card-feature">
            <img
              src="https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/da79a03cee486cbc129740a4104d3361.webp"
              alt="A polished,natural salon look"
            />
            <span className="inspiration-index">01 / HAIR STYLING</span>
            <div className="inspiration-caption">
              <span>THE SALON EDIT</span>
              <h3>A fresh cut,a softer finish.</h3>
            </div>
          </Reveal>
          <div className="inspiration-side">
            {looks.map((look, index) => (
              <Reveal
                className={look.className}
                delay={index * 0.1}
                key={look.title}
              >
                <img src={look.image} alt={look.alt} />
                <span className="inspiration-index">{look.category}</span>
                <div className="inspiration-caption">
                  <h3>{look.title}</h3>
                  <SafeIcon icon={FiArrowUpRight} />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Transformations;
